var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * BatteryFull component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconBatteryFull extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41624 5.00684C2.80338 5.00684 2.21563 5.25029 1.78228 5.68364C1.34892 6.117 1.10547 6.70475 1.10547 7.31761V16.6822C1.10547 17.2951 1.34892 17.8828 1.78228 18.3162C2.21563 18.7495 2.80338 18.993 3.41624 18.993H18.2435C18.8564 18.993 19.4442 18.7495 19.8775 18.3162C20.3109 17.8828 20.5543 17.2951 20.5543 16.6822V15.8715H21.3651C21.771 15.8715 22.1602 15.7102 22.4472 15.4232C22.7342 15.1362 22.8955 14.7469 22.8955 14.3411V9.65876C22.8955 9.25288 22.7342 8.86362 22.4472 8.57661C22.1602 8.28961 21.771 8.12837 21.3651 8.12837H20.5543V7.31761C20.5543 6.70475 20.3109 6.117 19.8775 5.68364C19.4442 5.25029 18.8564 5.00684 18.2435 5.00684H3.41624ZM2.84294 6.7443C2.99499 6.59226 3.20121 6.50684 3.41624 6.50684H18.2435C18.4586 6.50684 18.6648 6.59226 18.8168 6.7443C18.9689 6.89635 19.0543 7.10258 19.0543 7.31761V8.87837C19.0543 9.29259 19.3901 9.62837 19.8043 9.62837H21.3651C21.3731 9.62837 21.3809 9.63158 21.3866 9.63727C21.3923 9.64297 21.3955 9.6507 21.3955 9.65876V14.3411C21.3955 14.3491 21.3923 14.3569 21.3866 14.3626C21.3809 14.3682 21.3731 14.3715 21.3651 14.3715H19.8043C19.3901 14.3715 19.0543 14.7072 19.0543 15.1215V16.6822C19.0543 16.8972 18.9689 17.1035 18.8168 17.2555C18.6648 17.4076 18.4586 17.493 18.2435 17.493H3.41624C3.20121 17.493 2.99499 17.4076 2.84294 17.2555C2.69089 17.1035 2.60547 16.8972 2.60547 16.6822V7.31761C2.60547 7.10258 2.69089 6.89635 2.84294 6.7443ZM6.89771 9.65918C6.89771 9.24497 6.56192 8.90918 6.14771 8.90918C5.73349 8.90918 5.39771 9.24497 5.39771 9.65918V14.3415C5.39771 14.7557 5.73349 15.0915 6.14771 15.0915C6.56192 15.0915 6.89771 14.7557 6.89771 14.3415V9.65918ZM10.8298 8.90918C11.244 8.90918 11.5798 9.24497 11.5798 9.65918V14.3415C11.5798 14.7557 11.244 15.0915 10.8298 15.0915C10.4156 15.0915 10.0798 14.7557 10.0798 14.3415V9.65918C10.0798 9.24497 10.4156 8.90918 10.8298 8.90918ZM16.2622 9.65918C16.2622 9.24497 15.9264 8.90918 15.5122 8.90918C15.098 8.90918 14.7622 9.24497 14.7622 9.65918V14.3415C14.7622 14.7557 15.098 15.0915 15.5122 15.0915C15.9264 15.0915 16.2622 14.7557 16.2622 14.3415V9.65918Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconBatteryFull.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconBatteryFull.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconBatteryFull.prototype, "size", void 0);
if (customElements.get('cat-icon-battery-full') === undefined) {
    customElements.define('cat-icon-battery-full', BlocksIconBatteryFull);
}
